import React from "react";

const SearchPage = props => (
  <svg viewBox="0 0 18 24" fill="none" {...props}>
    <path
      d="M17.297 4.594L13.407.656A2.315 2.315 0 0011.811 0H2.25A2.25 2.25 0 000 2.25v19.5C0 23.016.984 24 2.25 24h13.5A2.25 2.25 0 0018 21.75V6.187c0-.562-.281-1.171-.703-1.593zm-1.031 1.078c.093.094.14.234.187.328H12V1.547c.094.047.234.094.328.187l3.938 3.938zM15.75 22.5H2.25a.74.74 0 01-.75-.75V2.25c0-.375.328-.75.75-.75h8.25v4.875c0 .656.469 1.125 1.125 1.125H16.5v14.25c0 .422-.375.75-.75.75z"
      fill="currentColor"
    />
    <path
      d="M16.898 21.533l-3.072-3.072c-.076-.05-.152-.102-.228-.102h-.33a5.317 5.317 0 001.294-3.453c0-2.894-2.386-5.281-5.28-5.281C6.361 9.625 4 12.012 4 14.906a5.277 5.277 0 005.281 5.281c1.32 0 2.514-.482 3.453-1.269v.33a.41.41 0 00.076.229l3.073 3.072c.127.127.33.127.431 0l.584-.584c.127-.102.127-.305 0-.432zM9.281 18.97a4.042 4.042 0 01-4.062-4.063 4.058 4.058 0 014.062-4.062 4.074 4.074 0 014.063 4.062A4.058 4.058 0 019.28 18.97z"
      fill="currentColor"
    />
  </svg>
);

export default SearchPage;
